export enum Enums {
	/** -------- Objective ENUMS --------- */

	/** Number */
	ZERO = 0,
	ONE = 1,
	TWO = 2,
	THREE = 3,
	FOUR = 4,
	FIVE = 5,
	TEN = 10,
	TWENTY_FIVE = 25,
	/** metricId default unit */
	NO_UNITS = 'NoUnits',
	PERCENTAGE = 'Percentage',
	/** Target Value */
	TARGET = 0,
	/** Default Goal Type */
	INDIVIDUAL = 'Individual',
	/** Default goalStatus Status Type */
	PUBLIC = 'Public',
	/** ---------- Objective ENUMS ENDS ----- */

	MAX_USER_SIZE = 999999,

	/** Confirm  dialog values*/
	DELETE_TEXT = 'Delete',
	UNLOCK_TEXT = 'Unlock',
	CONFIRM_TEXT = 'CONFIRM',

	/**  */
	ACTIVE = 'active',

	/** User team */
	USER_TEAM_SORTING = 'employeeTeamResponses.teamName',

	/** */
	DEFAULT_TYPE_CHAR = 1,
	/** Used to set Max input length for Current and Target */
	MAX_LENGTH_CURRENT_TARGET = 15,

	/** Status for API */
	STATUS_SUCCESS = 200,
	STATUS_BAD_REQUEST = 400,
	STATUS_SERVER_ERROR = 500,

	HIDE_SAVE_ANOTHER_BUTTON = 'true',

	KR_STATUS_PENDING = 1, //"Pending"
	KR_STATUS_ACCEPTED = 2, //"Accepted"
	KR_STATUS_DECLINED = 3, //"Declined"

	GOAL_STATUS_DRAFT = 1, //"DRAFT"
	GOAL_STATUS_PUBLIC = 2, //"PUBLIC"
	GOAL_STATUS_ARCHIVE = 3, // "ARCHIVE"

	skipOnboardingAction = 1,
	readyOnboardingAction = 2,
	MAX_LENGTH_ROLE_NAME = 12,
	USER_ROLE_ID = 4,
	LICENSE_THRESHOLD = 5,

	GLOBAL_SEARCH_PAGE_SIZE = 6,

	MAX_CADENCE_FOR_CHECKIN_NOTIFICATON = 30,
	MAX_PERIOD_FOR_EMAIL_TRIGGER = 30,
	GRACE_PERIOD = 90,

	/** CHECKIN STATUS */
	STATUS_CHECKED_ID = 2,
	NOT_YET_CHECKED_IN = 3,
	CHECKED_IN_MISSED = 1,
	CHECKED_IN_NO_DATA = 4,

	/** Cycle Status */
	FUTURE_CYCLE_ID = 3,
	CURRENT_CYCLE_ID = 2,
	PAST_CYCLE_ID = 1,

	/** SignalR Topics*/
	topicAddContributor = 'TopicAddContributor',
	topicDeleteOKR = 'TopicDeleteOKR',
	topicConversationTag = 'TopicConversationTag',
	topicNotesTag = 'TopicNotesTag',
	topicNudgeTeam = 'TopicNudgeTeam',
	topicUpdateOKRDueDate = 'TopicUpdateOKRDueDate',
	topicOKRCoach = 'TopicOKRCoach',
	topicNudge = 'TopicNudge',
	topicAcceptOKR = 'TopicAcceptOKR',
	topicDeclineOKR = 'TopicDeclineOKR',
	topicGivePersonalFeedback = 'TopicGivePersonalFeedback',
	topicFeedbackOneOnOne = 'TopicFeedbackOneOnOne',
	topicPersonalFeedback = 'TopicPersonalFeedback',
	topicUpdateKrScore = 'TopicUpdateKrScore',
	topicUpdateKrValueAlignmentMap = 'TopicUpdateKrValueAlignmentMap',
	topicSignalR = 'TopicSignalR',
}
